import { native } from '@forest/native-services'

export function closeShop() {
  void native.data.fullSync()
  void native.general.close()
}
